import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <path d="M15,2h-2V0h-3v2H6V0H3v2H1C0.448,2,0,2.448,0,3v12c0,0.552,0.448,1,1,1h14c0.552,0,1-0.448,1-1V3 C16,2.448,15.552,2,15,2z M14,14H2V7h12V14z" />,
  'Calendar',
);
